import OneColumnVariant from './OneColumnVariant';
import SocialMediaVariant from './SocialMediaVariant';
import TwoColumnVariant from './TwoColumnVariant';

import { ContentBlockClassNames, ContentBlockProps, ContentBlockVariants } from './types';
import { cn, getColorway, getYMargins } from 'utils/styles';

const ContentBlock = ({
  sys,
  variant,
  sectionName,
  margins,
  color,
  eyebrow,
  eyebrowAlternateLogo,
  eyebrowChimeLogo,
  headline,
  copy,
  cta,
  socialMedia,
  alignment,
  className,
}: ContentBlockProps) => {
  const internalClassNames: ContentBlockClassNames = {
    wrapper: cn(getYMargins(margins), getColorway(color), className?.wrapper),
    contentWrapper: cn('content-wrapper', className?.contentWrapper),
  };

  const renderedVariant = {
    [ContentBlockVariants.OneColumn]: (
      <OneColumnVariant
        sys={sys}
        eyebrow={eyebrow}
        eyebrowAlternateLogo={eyebrowAlternateLogo}
        eyebrowChimeLogo={eyebrowChimeLogo}
        headline={headline}
        copy={copy}
        cta={cta}
        alignment={alignment}
        className={className?.oneColumn}
      />
    ),
    [ContentBlockVariants.TwoColumn]: (
      <TwoColumnVariant
        sys={sys}
        eyebrow={eyebrow}
        eyebrowAlternateLogo={eyebrowAlternateLogo}
        eyebrowChimeLogo={eyebrowChimeLogo}
        headline={headline}
        copy={copy}
        cta={cta}
        alignment={alignment}
        className={className?.twoColumn}
      />
    ),
    [ContentBlockVariants.SocialMedia]: (
      <SocialMediaVariant sys={sys} headline={headline} socialMedia={socialMedia} className={className?.socialMedia} />
    ),
  }[variant];

  return (
    <div id={sectionName} className={internalClassNames.wrapper}>
      <div className={internalClassNames.contentWrapper}>{renderedVariant}</div>
    </div>
  );
};

export default ContentBlock;
